// Shared loader for /animation.json — the Motion catalog (see public/animation.json).
// ONE fetch, cached, so non-UI code (Dance Mode on a Character) can discover
// dance-tagged clips without owning its own fetch. The animation picker reads the
// same file for its dropdown; both go through here so there's a single source.

let _catalog = null
let _promise = null

// Load (once) and cache the catalog. Always resolves to a { animations: [...] }
// shape — a fetch/parse failure degrades to an empty catalog, never throws.
export async function loadAnimationCatalog() {
  if (_catalog) return _catalog
  if (!_promise) {
    _promise = fetch('/animation.json')
      .then((r) => r.json())
      .then((c) => (_catalog = c && Array.isArray(c.animations) ? c : { animations: [] }))
      .catch(() => (_catalog = { animations: [] }))
  }
  return _promise
}

// All catalog entries (empty until loadAnimationCatalog() has resolved once).
export function animationItems() {
  return _catalog?.animations || []
}
export function animationCatalogLoaded() { return _catalog !== null }

// Synchronous view of dance-tagged clip urls, in catalog order (used by Dance
// Mode's 'sequence' rotation). Empty until the catalog has loaded once — callers
// that might run before then should await loadAnimationCatalog() first.
export function danceClipUrls({ motionStudioEnabled = false } = {}) {
  return animationItems()
    .filter((a) => a.category === 'dance' && a.url)
    .filter((a) => !a.url.endsWith('.motion.json') || motionStudioEnabled)
    .map((a) => a.url)
}

// Dance Mode shows up as normal Motion-dropdown entries; the "rotating set" entries
// carry a SENTINEL value (not a clip url) so main.js routes them to startDancing()
// instead of setBaseAnimation(). This module owns that tiny encoding.
const DANCE_PREFIX = 'dance:'
export const danceSetValue = (mode) => DANCE_PREFIX + (mode === 'sequence' ? 'sequence' : 'shuffle')
export const parseDanceSet = (value) => {
  if (typeof value !== 'string' || !value.startsWith(DANCE_PREFIX)) return null
  return value.slice(DANCE_PREFIX.length) === 'sequence' ? 'sequence' : 'shuffle'
}
